import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import { StatusLabel } from '@shared/components';
import { useDocumentTitle } from '@shared/hooks';
import { TFolder, useFolder } from '@modules/items';

import { usePollInlineBlockDetection } from '../api/inlineBlocks.api';
import InlineBlockDetectionSummaryContent from '../components/inlineBlocks/InlineBlockDetectionSummaryContent';
import { EDetectionPollingStatus } from '../types/shared.types';

const InlineBlockDetectionSummary = () => {
  const { productId, runId } = useParams();

  const { error: detectionError, data: detectionData } = usePollInlineBlockDetection(runId);
  const { error: folderError, data: folder } = useFolder(productId);

  const error = detectionError || folderError;
  const data = useMemo(() => {
    if (detectionData && detectionData.status === EDetectionPollingStatus.READY && folder) {
      return {
        detection: detectionData,
        folder: folder as TFolder,
      };
    }
    return null;
  }, [detectionData, folder]);

  useDocumentTitle('Library detection summary');

  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading summary..."
      error={error}
      errorMessage="Loading summary failed!"
      render={(data) => (
        <InlineBlockDetectionSummaryContent
          run={data.detection.run}
          resolvedItems={data.detection.resolvedItems}
          folder={data.folder}
        />
      )}
    />
  );
};

export default InlineBlockDetectionSummary;
